import { NotFoundPage } from '@rhino-project/ui-heroui';
import { createFileRoute } from '@tanstack/react-router';
import LineupPage from '../../../../../../pages/lineups/LineupPage';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/lineups/$id/'
)({
  component: LineupPage,
  notFoundComponent: NotFoundPage
});
